/**
 * Dynamic Color Handler
 * Estrae i colori dalle classi color-XXXXXX e li applica come CSS custom properties
 */

class DynamicColorHandler {
    constructor() {
        this.init();
    }

    init() {
        // Aspetta che il DOM sia caricato
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.applyDynamicColors());
        } else {
            this.applyDynamicColors();
        }

        // Prova anche dopo un po' di tempo per elementi caricati dinamicamente
        setTimeout(() => this.applyDynamicColors(), 1000);
    }

    /**
     * Estrae il codice colore da una classe CSS
     * @param {string} className - Nome della classe (es: "color-FFBF64")
     * @returns {string|null} - Codice colore esadecimale o null se non trovato
     */
    extractColorFromClass(className) {
        const match = className.match(/color-([A-Fa-f0-9]{6})/);
        return match ? `#${match[1]}` : null;
    }

    /**
     * Applica i colori dinamici agli elementi
     */
    applyDynamicColors() {


        // Seleziona tutte le sezioni con classi color-
        const sections = document.querySelectorAll('.section-news[class*="color-"], .section-promo[class*="color-"], .section-trend .col[class*="color-"]');


        // Se non trova niente, prova selettori più generici
        if (sections.length === 0) {
            const allSections = document.querySelectorAll('[class*="color-"]');


            // Prova anche a cercare per classi specifiche
            const colorElements = document.querySelectorAll('.color-FFBF64, .section-news, .section-promo');

        }

        sections.forEach((section, index) => {


            const classList = Array.from(section.classList);


            let dynamicColor = null;

            // Cerca la classe color- nella lista delle classi
            for (const className of classList) {

                const color = this.extractColorFromClass(className);
                if (color) {
                    dynamicColor = color;

                    break;
                }
            }

            // Se ha trovato un colore, lo applica come CSS custom property
            if (dynamicColor) {
                section.style.setProperty('--dynamic-color', dynamicColor);


                // Verifica che sia stato applicato
                const appliedColor = getComputedStyle(section).getPropertyValue('--dynamic-color');

            } else {
                console.warn(`❌ No color found for section:`, section);
            }
        });

        // Applica anche a tutti gli elementi che contengono color- indipendentemente dalla struttura
        const allColorElements = document.querySelectorAll('[class*="color-"]');


        allColorElements.forEach((element, index) => {
            const classList = Array.from(element.classList);
            let dynamicColor = null;

            for (const className of classList) {
                const color = this.extractColorFromClass(className);
                if (color) {
                    dynamicColor = color;
                    break;
                }
            }

            if (dynamicColor) {
                element.style.setProperty('--dynamic-color', dynamicColor);

            }
        });
    }

    /**
     * Osserva i cambiamenti nel DOM per applicare i colori a nuovi elementi
     */
    observeChanges() {
        const observer = new MutationObserver((mutations) => {
            let shouldReapply = false;

            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const hasColorClass = node.classList && Array.from(node.classList).some(cls => cls.includes('color-'));
                            const containsColorElements = node.querySelectorAll && node.querySelectorAll('[class*="color-"]').length > 0;

                            if (hasColorClass || containsColorElements) {
                                shouldReapply = true;
                            }
                        }
                    });
                }
            });

            if (shouldReapply) {

                this.applyDynamicColors();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}

// Inizializza il gestore dei colori dinamici
const dynamicColorHandler = new DynamicColorHandler();

// Abilita l'osservazione dei cambiamenti del DOM
dynamicColorHandler.observeChanges();

export default DynamicColorHandler; 